import { motion, useMotionValue, useTransform } from "framer-motion";
import { useLocation } from "react-router-dom";
import Direction, { directionProp } from "./DirectionEnum";
import variants from "./animationVariants";
import { useEffect } from "react";
interface IProps {
    right?: () => void;
    left?: () => void;
    children: React.ReactNode;
}
const CardPage = (props: IProps) => {
    const limit = 100;
    const location = useLocation();
    const locationState: directionProp = location.state as directionProp;
    const x = useMotionValue(0);
    const opacity = useTransform(x, [-limit, 0, 0, limit], [0, 1, 1, 0]);
    let entryVariant = "entryInitial";
    if (locationState?.direction === Direction.Left) {
        entryVariant = "entryFromLeft";
    } else if (locationState?.direction === Direction.Right) {
        entryVariant = "entryFromRight";
    }
    useEffect(
        () =>
            x.onChange((latest) => {
                if (latest < -limit) {
                    if (props.left) {
                        props.left();
                    }
                }
                if (latest > limit) {
                    if (props.right) {
                        props.right();
                    }
                }
            }),
        [props, x]
    );

    return (
        <motion.div
            drag="x"
            dragMomentum={false}
            dragConstraints={{ right: 0, left: 0 }}
            dragElastic={0.6}
            style={{ x, opacity }}
            initial={entryVariant}
            animate="final"
            transition={{ duration: 0.7 }}
            variants={variants}
        >
            {props.children}
        </motion.div>
    );
};

export default CardPage;
